import React, { useEffect, useState } from "react";
import { useContext } from "react";
import Contexto from "../context/Contexto";
import "../assets/css/CCmenu.css";
import { Link } from "react-router-dom";

function Curso(props) {
  const { cliente, cursoscomprados, traemeColorClub, colorClub } =
    useContext(Contexto);
  const [tuColorClub, setTuColorClub] = useState([]);

  useEffect(() => {
    if (cursoscomprados.hasOwnProperty("color-club")) {
      traemeColorClub();
    }
  }, [cursoscomprados]);

  useEffect(() => {
    setTuColorClub(colorClub);
  }, [colorClub]);

  return (
    <>
      {cursoscomprados.hasOwnProperty("color-club") && (
        <>
          {tuColorClub.length > 0 ? (
            <h1 className="titular">EL CLUB</h1>
          ) : (
            <>
              <p className="titular">
                Para ser parte del Club comprá un plan en
              </p>
              <Link to="https://www.colorclub.online/" className="formuBT">
                COLOR CLUb
              </Link>
            </>
          )}

          <div className="colorClubContenedor">
            {tuColorClub.map((item, i) => {
              return (
                <>
                  <Link to={`/escuela/${item.url}`}>
                    <div
                      key={i}
                      style={{
                        background: item.color,
                      }}
                      className="CCtitulo"
                    >
                      <p>{item.nombre}</p>
                    </div>
                  </Link>
                </>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

export default Curso;
